export default __webpack_public_path__ + "static/media/4.922f1d0c.jpg";